/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import startReadAloudIcon from "dc-icons/viewer2021/SDC_ReadAloudListen_18_N.svg";
import * as constants from "constants/constants";
import ReadAloudCss from "components/readAloud/readAloud.css";

const mapStoresToProps = stores => ({
  icon: startReadAloudIcon,
  ariaLabel: "arialabel.readAloudStart",
  tooltipString: "tooltip.readAloudStart",
  tooltipPlacement: constants.TOOLTIP_BOTTOM_PLACEMENT,
  tooltipDelay: constants.TOOLTIP_DELAY,
  shouldEnableHover: true,
  className: ReadAloudCss.readAloudStartIcon,
  clickHandler: () => stores.readAloudStore.startHandler()
});

export const ReadAloudStartContainer = inject(mapStoresToProps)(ButtonWrapper);
